import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { BILLING_PATHS, buildUsageHref } from '../utils/paths';

// The 2026 Usage tab opens the AI card straight away, since that is what this link points at. The
// legacy LLM usage page is its own route, so it needs no card to open.
export function useAiUsageHref(): string {
  const isBillingUI2026Enabled = useFeatureFlag(AccountFeatureFlag.BillingUI2026);
  return isBillingUI2026Enabled ? buildUsageHref(['ai-usage']) : BILLING_PATHS.llmUsage;
}
